import {Grid, GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {InputSelectProjectByPatient} from '@/features/projects/components/input-select-project-by-patient/InputSelectProjectByPatient'
import {ProjectOverviewCard} from '@/features/projects/components/project-overview-card/ProjectOverviewCard'
import {ProjectFieldsSchema} from '@/features/projects/formSchemas'
import {useTranslation} from '@/translations/i18n'
import {useController, useFormContext, useWatch} from 'react-hook-form'
import {z} from 'zod'

const ProjectFormSourceSchema = ProjectFieldsSchema.pick({
    patient: true,
    referringProject: true,
    editingOperation: true
})
type ProjectFormSourceSchema = z.infer<typeof ProjectFormSourceSchema>

export const ProjectFormSourceField = () => {
    const {t} = useTranslation()
    const {control} = useFormContext<ProjectFormSourceSchema>()

    const patient = useWatch({control, name: 'patient'})

    const {field} = useController({control, name: 'referringProject'})

    return (
        <Grid columns={3} columnGap={4} rowGap={6} fullWidth>
            <GridItem spanColumn={2} fullWidth>
                <InputSelectProjectByPatient
                    label={t('commons:project_number')}
                    placeholder={t('commons:select_a_project')}
                    patientId={patient.id}
                    value={field.value}
                    onChange={value => field.onChange(value)}
                    disabled
                />
            </GridItem>
            {field.value && (
                <GridItem spanColumn={3} fullWidth>
                    <ProjectOverviewCard project={field.value} />
                </GridItem>
            )}
        </Grid>
    )
}
